<template>
    <!-- 公司文化 -->
    <div class="main">
        <div class="content">
            <sub-title
                title="公司文化"
                class="title"
            ></sub-title>

            <div class="inner-content">
                <div class="left-part">
                    <div
                        v-for="(item,index) in leftData"
                        :key="index"
                    >
                        <p class="left-part-title">{{ item.title }}</p>
                        <p class="left-part-text">{{ item.text }}</p>
                    </div>
                </div>
                <div class="right-part">
                    <p>分享成就与快乐从分担目标与任务开始</p>
                    <p>爱自己、爱家人、爱团队，努力做一个自己满意的人</p>
                    <p>以真诚和开放沟通，以包容和责任融合</p>
                    <p>吸纳正能量，远离抱怨与懈怠</p>
                    <p>不排斥和贬低任何一个新想法</p>
                    <p>让创新的种子不断发芽，成长，壮大</p>
                    <p>从脚下开始，不馁不燥，自信更务实</p>
                    <p>把目标和原则放在手上，而不仅仅停在嘴上</p>
                    <p>......</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SubTitle from '../../index/component/sub-title.vue';
export default {
    components: { SubTitle },
    data() {
        return {
            leftData: [
                {
                    title: '使命',
                    text: '引领智慧工程，共创美好生活。',
                },
                {
                    title: '愿景',
                    text: '领先的工程建设SAAS服务提供商。',
                },
                {
                    title: '价值观',
                    text: '成就客户、务实守信、合作共进、创新发展。',
                },
                {
                    title: '发展理念',
                    text: '做实、做强、做大、做好、做长。',
                },
                {
                    title: '企业精神',
                    text: '务实、专业、协同、奉献。',
                },
            ],
        };
    },
    mounted() {},
    methods: {},
};
</script>
<style lang='scss' scoped>
.main {
    width: 100%;
    height: 818px;
    background: url(/images/about/bg_2.png) no-repeat;
    background-size: 100% 100%;
    padding-top: 93px;
    .inner-content {
        height: 569px;
        width: 100%;
        display: flex;
        padding: 74px 0px 62px 123px;
        margin-top: 65px;
        background: #fff;

        .left-part {
            width: 430px;
            border-right: 1px solid #d1d1d1;
            display: flex;
            flex-flow: column;
            justify-content: space-between;
            padding-bottom: 15px;
            .left-part-title {
                font-size: 20px;
                color: #333333;
                font-weight: bold;
            }
            .left-part-text {
                font-size: 16px;
                letter-spacing: 0px;
                color: #333333;
                margin-top: 15px;
            }
        }

        .right-part {
            padding-left: 100px;
            font-size: 20px;
            line-height: 52px;
            color: #333333;
            letter-spacing: 1px;
        }
    }
}
</style>
